// Remembers which ad campaign brought the guest, so the booking can be attributed to it.
// Ads link straight to the widget, so the click parameters are on the landing URL.
const STORAGE_KEY = 'reserveport_attribution'
const CLICK_WINDOW_DAYS = 90
const PARAMS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid',
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

// Reads parameters from both the query string and the hash route (#/?pid=..&gclid=..).
function landingParams () {
  const found = {}
  const sources = [window.location.search, (window.location.hash.split('?')[1] || '')]
  for (const source of sources) {
    const params = new URLSearchParams(source)
    for (const name of PARAMS) {
      const value = params.get(name)
      if (value) {
        found[name] = value.substring(0, 255)
      }
    }
  }
  return found
}

// Call once on page load. A new campaign visit replaces the old one;
// a later visit without campaign parameters keeps the stored campaign.
export function captureAttribution () {
  try {
    const params = landingParams()
    if (!Object.keys(params).length) {
      return
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign(params, {
      landing_url: window.location.href.substring(0, 1000),
      referrer: document.referrer.substring(0, 1000),
      captured_at: new Date().toISOString()
    })))
  } catch (error) {
    // storage unavailable: booking is simply not attributed
  }
}

// Campaign details to send with a reservation, or null when the guest didn't come from a campaign.
export function getAttribution () {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY))
    if (!stored) {
      return null
    }
    const ageDays = (Date.now() - new Date(stored.captured_at).getTime()) / 86400000
    if (!(ageDays <= CLICK_WINDOW_DAYS)) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return stored
  } catch (error) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/attribution.js